import CompanyApi from '@/api-interface/company'

export default {
  namespaced: true,

  state: {
    currentCompanyInfo: {
      companyKey: 0,
      createdTimestamp: null,
      updatedTimestamp: null,
      companyPhones: [
        {
          companyPhoneDigits: null,
          companyPhonePrimaryFlag: true,
          companyPhoneType: 'office'
        }
      ],
      companyAddresses: [
        {
          companyAddressCity: '',
          companyAddressState: '',
          companyAddressStreet1: '',
          companyAddressStreet2: '',
          companyAddressZip: ''
        }
      ],
      companyDunAndBradStreetNumber: '',
      companyIndustry: '',
      companyName: '',
      companyTaxId: '',
      factoringProviderKey: null,
      companyEquipmentPreferences: [
        {
          companyEquipmentPreferenceKey: 0,
          createdTimestamp: '',
          updatedTimestamp: '',
          companyEquipmentPreferenceDescription: ''
        }
      ],
      companyLanesRoutes: [
        {
          companyLanesRoutesKey: 0,
          createdTimestamp: '',
          updatedTimestamp: '',
          companyLanesRoutesDescription: ''
        }
      ]
    },
    users: []
  },

  getters: {
    companyUsers(state, getters, rootState, rootGetters) {
      return state.users.map((user) => ({
        ...user,
        isCurrentUser: rootGetters['user/accountInfo'].accountKey === user.accountKey
      }))
    }
  },

  mutations: {
    SET_COMPANY_INFO(state, companyInfo) {
      state.currentCompanyInfo = Object.assign({}, state.currentCompanyInfo, companyInfo)
    },

    SET_COMPANY_USER_LIST(state, userList) {
      state.users = userList
    }
  },

  actions: {
    async getUsers({ commit, state }, key) {
      const companyKey = key || state.currentCompanyInfo.companyKey
      const response = await CompanyApi.getCompanyUsers(companyKey)
      commit('SET_COMPANY_USER_LIST', response)
    },

    async updateDetails({ commit }, companyInfo) {
      const response = await CompanyApi.update(companyInfo)
      commit('SET_COMPANY_INFO', response)
    },

    async getDetails({ commit }, companyKey) {
      const response = await CompanyApi.getDetails(companyKey)
      commit('SET_COMPANY_INFO', response)
    }
  }
}
